import { useRouter } from "next/router";
import type React from "react";
import { useRef } from "react";
import { authPaths, useAuth } from "@medbillai/app/lib/auth";
import { useSignUpOnboardingStore } from "@medbillai/app/lib/sign-up-onboarding/signUpOnboardingStore";
import { anonymousSessionStorage } from "@medbillai/app/lib/storage";
import { FullscreenSpinner } from "@medbillai/ui";
import { buildUrlWithParams, homeUrl, loginUrl } from "@medbillai/utils/urls";
export const AuthGate = (props: {
  children: React.ReactNode;
}) => {
  const {
    isReady,
    isAuthenticated,
    setIntendedPath
  } = useAuth();
  const {
    replace,
    pathname,
    query,
    isReady: routerIsReady
  } = useRouter();
  const redirectedRef = useRef(false);
  const {
    setIsSignUpOnboarding
  } = useSignUpOnboardingStore();
  if (!isReady || !routerIsReady) {
    return <FullscreenSpinner />;
  }
  if (!isAuthenticated) {
    if (!redirectedRef.current) {
      redirectedRef.current = true;
      const anonToken = typeof query.anonToken === "string" ? query.anonToken : null;
      if (anonToken) {
        void anonymousSessionStorage.set("token", anonToken);
        setIsSignUpOnboarding(true);
      }

      // Only store paths that aren't auth-related and aren't the home page
      const shouldStorePath = pathname !== "/" && !authPaths.includes(pathname);
      if (shouldStorePath) {
        const {
          anonToken: _,
          ...rest
        } = query;
        setIntendedPath(buildUrlWithParams(pathname, rest));
      }
      void replace(loginUrl());
    }
    return <FullscreenSpinner />;
  }

  // If authenticated and on an auth page, redirect to home
  if (isAuthenticated && authPaths.includes(pathname)) {
    if (!redirectedRef.current) {
      redirectedRef.current = true;
      void replace(homeUrl());
    }
    return <FullscreenSpinner />;
  }
  return <>{props.children}</>;
};